var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pageContainer',{attrs:{"formHeaderImage":_vm.NavImage,"formHeaderImageAltText":"VasInformation Header Image","formHeaderImageClass":"mb-4","formHeaderImageWidth":"85%","isPageHeader":true}},[_c('vasInformation')],1),(false)?_c('GetHelp'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }